var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicsSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 27.5H27.5C24.7375 27.5 22.5 29.7375 22.5 32.5V62.5C22.5 65.2625 24.7375 67.5 27.5 67.5H40V72.5H60V67.5H72.5C75.2625 67.5 77.475 65.2625 77.475 62.5L77.5 32.5C77.5 29.7375 75.2625 27.5 72.5 27.5ZM72.5 62.5H27.5V32.5H72.5V62.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicsSystemActive);
export default __webpack_public_path__ + "static/media/electronicsSystemActive.1738b7f3bbcb88aecdde82a6d4cf7395.svg";
export { ForwardRef as ReactComponent };